import { Button, FormGroup, Label } from "reactstrap";
import { ErrorMessage, Field, Form } from "formik";
import ReactDatePicker from "react-datepicker";
import { getDate } from "../../../../../helper/utility";
import { DataView, TableColumn } from "../../../../../components/table/table";
import { DataType } from "ka-table/enums";
import ReactSelect from "react-select";

export const ReviewAndUploadForm = ({
    formProps,
    fileUpload,
    selectedSheetIndex,
    setSelectedSheetIndex,
    setCurrentPage,
    reviewColumns,
    mappedRows,
    rowData,
    selectedRowIdsBySheet,
    handleSelectionChange,
    currentPage,
    rowCount,
    limit,
    updatePagination,
    app,
    matchedSheet,
    isSelectionValid,
  }: any) => {
    return (
      <Form className="mx-0" onSubmit={formProps.handleSubmit}>
        <div className="row file-process-header data-mapping">
          <div className="col-6 d-flex gap-3 floating-input px-0 ">
            <FormGroup className="form-floating ps-0 w-100">
              <Field
                value={formProps.values.name}
                className="form-control"
                name="name"
                placeholder="Enter Job Name"
              />
              <Label>Job Name</Label>
            </FormGroup>
            <FormGroup className="form-floating ps-0 w-100">
              <ReactSelect
                menuPortalTarget={document.body}
                menuPlacement="auto"
                menuPosition="fixed"
                isClearable={false}
                value={fileUpload.map((file: any, index: any) => ({
                  value: index,
                  label: `${file.file.name} - ${file.selectedSheet?.[0]?.name || "No Sheet"}`,
                }))[selectedSheetIndex]}
                onChange={(newValue: any) => {
                  setSelectedSheetIndex(newValue?.value || 0);
                  setCurrentPage(0);
                }}
                options={fileUpload.map((file: any, index: any) => ({
                  value: index,
                  label: `${file.file.name} - ${file.selectedSheet?.[0]?.name || "No Sheet"}`,
                }))}
                placeholder="Select Sheet"
              />
              {/* <Label>Sheet Selection</Label> */}
            </FormGroup>
          </div>
          <div className="col-6">
            <div className="d-flex flex-wrap">
              <div className="me-4">
                <strong>File Type:</strong>{" "}
                {fileUpload[selectedSheetIndex]?.file?.name
                  ? fileUpload[selectedSheetIndex].file.name.split(".").pop()?.toUpperCase()
                  : "-"}
              </div>
              <div className="me-4">
                <strong>Sheet:</strong>{" "}
                {fileUpload[selectedSheetIndex]?.file?.name && matchedSheet?.name
                  ? `${fileUpload[selectedSheetIndex].file.name} - ${matchedSheet.name}`
                  : "-"}
              </div>
              <div>
                <strong>Function:</strong> {matchedSheet?.functionCode || "-"}
              </div>
            </div>
          </div>
  
          {app.currentApp.appCode === "rdo" && (
            <>
              <FormGroup className="col-3 form-floating sticky_label ps-0 mt-2">
                <Field
                  name="startDate"
                  component={ReactDatePicker}
                  placeholderText={"DD/MM/YYYY"}
                  dateFormat={"dd/MM/yyyy"}
                  className="form-control w-100"
                  selected={getDate(formProps.values?.startDate)}
                  onChange={(date: any) => {
                    formProps.setFieldValue("startDate", date);
                  }}
                />
                <ErrorMessage
                  name="startDate"
                  component="div"
                  className="text-danger"
                />
                <Label>
                  From Date<span style={{ color: "red" }}>*</span>
                </Label>
              </FormGroup>
              <FormGroup className="col-3 form-floating ps-0 mt-2 form-floating sticky_label">
                <Field
                  name="endDate"
                  component={ReactDatePicker}
                  placeholderText={"DD/MM/YYYY"}
                  dateFormat={"dd/MM/yyyy"}
                  className="form-control w-100"
                  selected={getDate(formProps.values?.endDate)}
                  onChange={(date: any) => {
                    formProps.setFieldValue("endDate", date);
                  }}
                />
                <ErrorMessage
                  name="endDate"
                  component="div"
                  className="text-danger"
                />
                <Label>
                  to Date<span style={{ color: "red" }}>*</span>
                </Label>
              </FormGroup>
            </>
          )}
  
          <div className="mt-2">
            <DataView
              columns={[
                {
                  key: "selection-cell",
                  title: "",
                  dataType: DataType.Boolean,
                  width: "50px",
                },
                {
                  key: "srNo",
                  title: "Sr. No",
                  dataType: DataType.Number,
                  width: "70px",
                },
                ...reviewColumns,
              ]}
              rows={mappedRows}
              allRows={rowData}
              keyId="tableId"
              striped={true}
              isLoading={false}
              hideRowHeader={false}
              selectedRows={selectedRowIdsBySheet[selectedSheetIndex] || []}
              onSelectionChange={handleSelectionChange}
              isSearchDisable={true}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              rowCount={rowCount}
              limit={limit}
              updatePagination={updatePagination}
            />
          </div>
        </div>
        <Button
          color="primary"
          className="review-submit"
          aria-owns="maping-btn-box"
          type="submit"
        >
          Submit
        </Button>
      </Form>
    );
  };